//@ts-nocheck
// Dedicated BrainTree hosted-fields (credit card) wiring for self-service RMA "add payment"
// (collecting an exchange upcharge). This is a deliberate copy of AoeBraintree.ts rather than
// a shared/generalized module: that file hardcodes the cart identifier field name
// (aOECartIdToken) into the payment-submit payload, so it can't safely represent an RMA
// payment. Keeping this separate means the live checkout payment code is untouched.
function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null
  return null
}

export const AoeBraintreeRma = {
  clientToken: '',
  hfSubmitBtn: '',
  refreshBtn: '',
  requestSource: '',
  bearerToken: '',
  enableThreeDSecure: false,
  hostedFieldsText: {
    cardholderName: '',
    creditCardNumber: '',
    cvv: '',
    expirationDate: '',
  },
  sourceValues: {
    systemKeyword: '',
    rmaNumber: '',
  },
  createPaymentUrl: '',
  apiKey: '',
  isUpdateMode: false,
  Initialize: function () {
    console.log('Loading RMA Braintree')
    window.postMessage({ messageType: 'aoepaymentmethodloading' })
    braintree.client.create(
      {
        authorization: AoeBraintreeRma.clientToken,
      },
      function (err, clientInstance) {
        console.debug('braintree.client.create')
        if (err) {
          console.error(err, AoeBraintreeRma.clientToken)
          return
        }

        let threeDSecureInstance = null
        if (AoeBraintreeRma.enableThreeDSecure && braintree?.threeDSecure?.create) {
          braintree.threeDSecure.create(
            {
              client: clientInstance,
              version: 2,
            },
            function (threeDSErr, instance) {
              if (threeDSErr) {
                console.error('threeDSecure.create error', threeDSErr)
                threeDSecureInstance = null
              } else {
                threeDSecureInstance = instance
              }
            },
          )
        }

        const fieldsConfig = {
          cardholderName: {
            selector: '#aoetbtNameOnCard',
            placeholder: AoeBraintreeRma.hostedFieldsText.cardholderName,
          },
          number: {
            selector: '#aoetbtCreditCardNumber',
            placeholder: AoeBraintreeRma.hostedFieldsText.creditCardNumber,
          },
          cvv: {
            selector: '#aoetbtCreditCardCVV',
            placeholder: AoeBraintreeRma.hostedFieldsText.cvv,
          },
          expirationDate: {
            selector: '#aoetbtCreditCardExpirationDate',
            placeholder: AoeBraintreeRma.hostedFieldsText.expirationDate,
          },
        }

        braintree.hostedFields.create(
          {
            client: clientInstance,
            styles: {
              input: {
                color: '#495057',
                'font-size': '1rem',
                transition: 'color 0.1s',
                'line-height': 'revert',
              },
              'input.invalid': {
                color: '#E53A40',
              },
              'input:-ms-input-placeholder': {
                'line-height': '1.5em',
              },
              '::-webkit-input-placeholder': {
                color: 'rgba(black, 0.6)',
                'line-height': '1.5em',
              },
              ':-moz-placeholder': {
                color: 'rgba(black, 0.6)',
              },
              '::-moz-placeholder': {
                color: 'rgba(black, 0.6)',
              },
              ':-ms-input-placeholder': {
                color: 'rgba(black, 0.6)',
              },
            },
            fields: fieldsConfig,
          },
          function (err, hostedFieldsInstance) {
            window.postMessage({ messageType: 'aoepaymentmethodloaded' })
            console.debug('braintree.hostedFields.create')
            if (err) {
              console.error(err)
              return
            }

            const submit = document.querySelector('#aoetbtSubmit')
            const nonce = document.querySelector('#aoetbtNonce')

            // Keep the button disabled until hosted fields report the form is valid - the
            // template already defaults it to disabled, but this covers the (unlikely) case
            // where validityChange doesn't fire before the user can interact
            submit.disabled = true

            hostedFieldsInstance.on('validityChange', function (event) {
              const formValid = Object.keys(event.fields).every(function (key) {
                return event.fields[key].isValid
              })

              if (formValid) {
                submit.disabled = false
              } else {
                submit.disabled = true
              }
            })

            submit.addEventListener(
              'click',
              function (event) {
                event.preventDefault()
                hostedFieldsInstance.tokenize(function (err, payload) {
                  console.debug('tokenize')
                  if (err) {
                    console.error('tokenize error', err)
                    const message = {
                      messageType: 'aoepaymentcreationerror',
                      messageData: err,
                    }
                    window.postMessage(message)
                    return
                  }
                  nonce.value = payload.nonce

                  if (AoeBraintreeRma.enableThreeDSecure && threeDSecureInstance && threeDSecureInstance.verifyCard) {
                    const aoetbtPaymentAmount = document.querySelector('#aoetbtPaymentAmount')
                    let charge = '0'
                    if (aoetbtPaymentAmount) {
                      const amountAttr = aoetbtPaymentAmount.getAttribute('data-amount')
                      charge = amountAttr != null && amountAttr !== '' ? amountAttr : '0'
                    }

                    const bin = payload?.details?.bin
                    if (!bin) {
                      AoeBraintreeRma.CreatePayment(payload)
                      return
                    }

                    threeDSecureInstance.verifyCard(
                      {
                        amount: charge,
                        nonce: payload.nonce,
                        bin,
                        challengeRequested: true,
                        onLookupComplete: function (_data, next) {
                          next()
                        },
                      },
                      function (verifyErr, threeDSPayload) {
                        if (verifyErr) {
                          console.error('threeDSecure.verifyCard error', verifyErr)
                          const verifyErrCode =
                            typeof verifyErr === 'object' &&
                            verifyErr !== null &&
                            'code' in verifyErr
                              ? (verifyErr as { code?: unknown }).code
                              : undefined
                          if (verifyErrCode === 'THREEDS_USER_CANCELED') {
                            window.postMessage({
                              messageType: 'aoepaymentcreation3dsusercanceled',
                              messageData: verifyErr,
                            })
                            return
                          }
                          window.postMessage({
                            messageType: 'aoepaymentcreationerror',
                            messageData: verifyErr,
                          })
                          return
                        }

                        const threeDSInfo =
                          typeof threeDSPayload === 'object' &&
                          threeDSPayload !== null &&
                          'threeDSecureInfo' in threeDSPayload
                            ? (threeDSPayload as { threeDSecureInfo?: unknown }).threeDSecureInfo
                            : undefined
                        const threeDSStatus =
                          typeof threeDSInfo === 'object' &&
                          threeDSInfo !== null &&
                          'status' in threeDSInfo
                            ? (threeDSInfo as { status?: unknown }).status
                            : undefined
                        if (threeDSStatus === 'challenge_required') {
                          window.postMessage({
                            messageType: 'aoepaymentcreation3dsusercanceled',
                            messageData: threeDSInfo,
                          })
                          return
                        }
                        if (
                          threeDSStatus &&
                          threeDSStatus !== 'authenticated' &&
                          threeDSStatus !== 'authenticate_successful'
                        ) {
                          console.error('threeDSecure.verifyCard not authenticated', threeDSStatus, threeDSInfo)
                          window.postMessage({
                            messageType: 'aoepaymentcreationerror',
                            messageData: threeDSInfo,
                          })
                          return
                        }

                        nonce.value = threeDSPayload.nonce
                        const nextPayload = {
                          ...payload,
                          nonce: threeDSPayload.nonce,
                          threeDSecureInfo: threeDSPayload.threeDSecureInfo,
                        }
                        AoeBraintreeRma.CreatePayment(nextPayload)
                      },
                    )
                  } else {
                    AoeBraintreeRma.CreatePayment(payload)
                  }
                })
              },
              false,
            )
          },
        )
      },
    )
  },
  CreatePayment: function (payload) {
    console.debug('SavePayment', payload)
    const aoetbtPaymentAmount = document.querySelector('#aoetbtPaymentAmount')
    let charge = ''
    if (aoetbtPaymentAmount) {
      const amountAttr = aoetbtPaymentAmount.getAttribute('data-amount')
      charge = amountAttr != null && amountAttr !== '' ? amountAttr : '0'
    } else {
      charge = '0'
    }

    const jsonDataToSave = {
      systemKeyword: AoeBraintreeRma.sourceValues.systemKeyword,
      rMANumber: AoeBraintreeRma.sourceValues.rmaNumber,
      BraintreeHostedFieldTokenizeResponse: {
        ...payload,
        clientToken: AoeBraintreeRma.clientToken,
      },
      charge: Number(charge),
      responseDefinition: {
        responseType: 1,
      },
    }
    if (
      AoeBraintreeRma.createPaymentUrl &&
      AoeBraintreeRma.createPaymentUrl.length > 0
    ) {
      const headers: Record<string, string | null> = {
        'x-api-key': AoeBraintreeRma.apiKey,
        Authorization: AoeBraintreeRma.bearerToken ? `Bearer ${AoeBraintreeRma.bearerToken}` : null,
      }
      const debugLoggingId = getCookie('X-Debug-Logging-Id')
      if (debugLoggingId) {
        headers['X-Debug-Logging-Id'] = debugLoggingId
      }

      jQuery.ajax({
        type: 'POST',
        url: AoeBraintreeRma.createPaymentUrl,
        data: JSON.stringify(jsonDataToSave),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: headers,
        success: function (result) {
          console.log('Processing complete', result)
          window.postMessage({
            messageType: 'aoepaymentcreated',
            messageData: result,
            paymentData: jsonDataToSave,
          })
        },
        error: function (result) {
          console.log('Processing error', result)
          window.postMessage({
            messageType: 'aoepaymentcreationerror',
            messageData: result.responseJSON,
          })
        },
      })
    } else {
      console.error('createPaymentUrl is empty')
    }
  },
}
